import { useFormikContext } from 'formik';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useDreFormContext } from 'pages/financeiro/dre/contexts/DreFormContext';
import { DreForm, RequestDreForm } from 'pages/financeiro/dre/types';

export function useRecalculateDre() {
    const { setDre, setStatus } = useDreFormContext();
    const { mutateAsync, isLoading } = useFormMutation<RequestDreForm>();
    const { showError } = useShowError();
    const { validateForm, values, setErrors } = useFormikContext<DreForm>();

    /**
     * Realiza o recalculo automático dos valores do DRE.
     */
    const recalculateDre = () => {
        setStatus('RECALCULATING');

        return mutateAsync(
            {
                url: '/dre/dremercadologicawrapper/recalcula',
                formData: values,
                preventSnack: true,
            },
            {
                onSuccess: ({ data }) => setDre(data.data),
                onError: (error) => showError(error, 'Ocorreu um erro ao fazer o recalculo automático dos valores.'),
                onSettled: () => setStatus(null),
            },
        );
    };

    /**
     * Recalcula a DRE após a validação do formulário.
     */
    const recalculateValidatedDre = () =>
        validateForm().then((errors) => {
            setErrors(errors);

            if (Object.keys(errors).length) {
                return false;
            }

            return recalculateDre()
                .then(() => true)
                .catch(() => false);
        });

    return { recalculateDre, recalculateValidatedDre, isLoading };
}
